import { useFileStackContext } from "./useFileStackContext";

export interface UseFilestackImageUrlOptions {
  width: number;
  quality?: number;
  defaultUrl?: string | null;
}

export const useFilestackImageUrl = (
  handle: string | null | undefined,
  options: UseFilestackImageUrlOptions
): string | null => {
  const { filestack } = useFileStackContext();

  if (handle && filestack) {
    return filestack.transform(handle, {
      resize: { width: options.width },
      quality: { value: options.quality ?? 80 },
    });
  }

  return options.defaultUrl ?? null;
};
